export default __webpack_public_path__ + "static/media/ideate.2d83f0c2.svg";